window.config = {
  AxiosTimeout: 10000,//axios请求超时时间
  // SecondBigImg: 'https://guangfu-1300435598.cos.ap-guangzhou.myqcloud.com/renogyCalculator/side.png',//房车内饰
  // ApiBaseURL: 'http://renogycalculator.yftq.jchorn.com/api/',//本地测试接口地址
  // ApiBaseURL: 'https://dev-guangfucgi.sparkers.net/api/',//线上测试地址
  // loginURL: 'http://39.103.13.231/dchome_app/api/v1/user/login',//开发登录地址
  // loginURL: 'http://dev-gateway.renogy.cn/api/v1/auth/login',//最新测试登录地址
  //正式部署
  ApiBaseURL: process.env.API_PATH.ApiBaseURL,//正式地址
  // loginURL: 'https://www.renogy-dchome.com/dchome_app_update/api/v1/user/login',//正式登录地址
  loginURL: process.env.API_PATH.loginURL,//最新正式登录地址
  getBannerURL: process.env.API_PATH.getBannerURL,//获取左侧图的地址
  siginURL: process.env.API_PATH.siginURL,//注册
  siginValidateEmail: process.env.API_PATH.siginValidateEmail, // 注册验证邮箱
  sendVerifyCodeURl: process.env.API_PATH.sendVerifyCodeURl,//验证码
  SecondBigImg: process.env.API_PATH.SecondBigImg,//房车内饰
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 8